import { useEffect, useState } from "react";
import { getBrowserFingerPrint } from "services/fingerprint";

export const useBrowserDeviceFingerprint = () => {
  const [deviceFingerprint, setDeviceFingerprint] = useState(null);

  useEffect(() => {
    const fetchFingerprint = async () => {
      const result = await getBrowserFingerPrint();
      setDeviceFingerprint(result);
    };

    fetchFingerprint();
  }, []);

  return {
    deviceFingerprint
  };
};
